import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CourseCardContainer = styled(Box)`
  width: 100%;
  border-radius: 10px;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  padding: 24px 16px;
  display: flex;
  gap: 14px;
  flex: 1;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    gap: 32px;
    flex-direction: row;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 24px;
    gap: 32px;
  }
`;

export const Title = styled(Typography)`
  height: fit-content;
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    font-size: 24px;
    line-height: 24px;
  }
`;

export const ImageWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  & > div {
    width: 100%;
  }
  img {
    border-radius: 10px;
    height: 178px;
  }
  ${({ theme }) => theme.breakpoints.up('sm')} {
    img {
      max-width: 273px;
    }
  }
`;

export const Button = styled('div')`
  display: flex;
  height: 40px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #00532a;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  color: #00532a;
`;
